import React from "react";
import styled from "styled-components";
import { Field, useField } from "formik";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import { TextField } from "formik-material-ui";

import COLORS from "../../../assets/colors";
import { SortString } from "../../../helpers/SortString";

export default ({
  list = [],
  name,
  label,
  width,
  margin,
  disabled = false,
  handleChange,
  isRequired = false
}) => {
  const [field, meta, helpers] = useField(name);
  // console.log("field, meta", field, meta, helpers);

  return (
    <FormControlTag width={width} margin={margin}>
      <Field
        component={TextField}
        type="text"
        name={name}
        label={
          <span>
            {label} {isRequired && <span className="astric">*</span>}
          </span>
        }
        select
        disabled={disabled}
        variant="standard"
        // helperText="Please select Range"
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) =>
          !!handleChange ? handleChange(e) : helpers.setValue(e.target.value)
        }
      >
        {list.map((el, i) => (
          <StyledMenuItem value={el.value} key={i}>
            {el.label}
          </StyledMenuItem>
        ))}
      </Field>
    </FormControlTag>
  );
};

const StyledMenuItem = withStyles((theme) => ({
  root: {
    fontSize: 12,
    "&:focus": {
      backgroundColor: COLORS.ASH_WHITE,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const FormControlTag = styled(FormControl)`
  &.MuiFormControl-root {
    padding: 0px;
    width: ${(props) => (props.width ? props.width : "150px")};
    margin: ${(props) => (props.margin ? props.margin : undefined)};
    .MuiFormControl-marginNormal {
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .MuiSelect-selectMenu {
      font-size: 12px;
      font-weight: 400;
      /* padding-left: 10px; */
      padding: 9px 30px 9px 10px;
    }
    label {
      color: ${COLORS.TITLE_BLUE};
      font-size: 16px;
      font-weight: 600;
      font-family: inherit;
      line-height: 20px;
      transform: none;
      white-space: nowrap;
      .astric {
        color: ${COLORS.PRIMARY_RED};
      }
    }
    label + .MuiInput-formControl {
      border: solid 1px ${COLORS.C4_BORDER};
      border-radius: 4px;
      margin-top: 32px;
      min-height: 38px;
      &.Mui-error {
        border-color: ${COLORS.PRIMARY_RED};
      }
      &:before,
      &:after {
        display: none;
      }
    }
  }
`;
